/**
 * 用户登录
 */
export async function requestLogin(data: LoginReq): Promise<Res<LoginRes>> {
  return http.post('/v1/auth/login', data)
}
